export enum L {
  VERBOSE,
  DEBUG,
  INFO,
  WARN,
  ERROR,
}
const LEVEL_MAP = new Map([
  [L.VERBOSE, "VERB"],
  [L.DEBUG, "DEBG"],
  [L.INFO, "INFO"],
  [L.WARN, "WARN"],
  [L.ERROR, "ERR!"],
]);

let LOG_LEVEL = L.ERROR;

export function logLevel<A extends Array<any>, B>(
  level: L,
  func: (...args: A) => B
): (...args: A) => B {
  return (...args: A) => {
    const original = LOG_LEVEL;
    LOG_LEVEL = level;
    const result = func(...args);
    LOG_LEVEL = original;
    return result;
  };
}

export function asyncLogLevel<A extends Array<any>, B>(
  level: L,
  func: (...args: A) => Promise<B>
): (...args: A) => Promise<B> {
  return async (...args: A) => {
    const original = LOG_LEVEL;
    LOG_LEVEL = level;
    const result = await func(...args);
    LOG_LEVEL = original;
    return result;
  };
}

export function log(level: L, text: string) {
  if (level >= LOG_LEVEL) {
    console.log(`[${LEVEL_MAP.get(level) ?? "????"}]: ${text}`);
  }
}
